import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api as ApiMyRadiant } from "../../api/api";

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  //url: string = 'http://172.24.3.7/radiant/api';
  // url: string = 'http://localhost/radiant/mobile-api';
  // url: string = 'http://172.31.1.125/radiant/mobile-api';  //->LOCALHOST
  //url: string = 'http://172.31.1.110/radiant/mobile-api';
  // url: string = 'http://202.147.194.34/api';
  // url:string ='https://202.182.55.114:8013/api';
  // url: string = 'http://202.147.194.34/api_trial';
  // url: string = 'http://202.147.194.34/api_brawijaya';
  url = this.apiMyRadiant.url;


  constructor(public http: HttpClient, public apiMyRadiant: ApiMyRadiant) {
  }

  getOri(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
   
    return this.http.get(this.url + '/' + endpoint, reqOpts);
  }
  
  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }
    reqOpts.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
   
    return this.http.get(this.url + '/' + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any) {
    if(reqOpts==undefined){
      reqOpts = {};
    }
    reqOpts.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    let params = this.serialize(body);
    return this.http.post(this.url + '/' + endpoint, params, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.url + '/' + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.patch(this.url + '/' + endpoint, body, reqOpts);
  }

  serialize(obj) {
    var str = "";
    for (var key in obj) {
        if (str != "") {
            str += "&";
        }
        str += key + "=" + encodeURIComponent(obj[key]);
    }
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/providers/advance_providers/api/api.ts